export default __webpack_public_path__ + "static/media/Loader.e1284f3a.gif";